import { createContext, useContext } from 'react';
import { Brand } from '../../data/index.js';
export const BrandingContext = createContext({
    brand: Brand.Astrumu
});
export const useBrandingContext = () => useContext(BrandingContext);
//# sourceMappingURL=index.js.map